import { render, staticRenderFns } from "./userAppointmentParticulars.vue?vue&type=template&id=4581d73e&scoped=true&"
import script from "./userAppointmentParticulars.vue?vue&type=script&lang=js&"
export * from "./userAppointmentParticulars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4581d73e",
  null
  
)

export default component.exports